import { supabase } from '../lib/supabase';

/**
 * Alternative approach to get user and update with email tracking
 */
export const updateProjectWithEmailTracking = async (projectId, field, value) => {
  console.log('=== Alternative Email Tracking Update ===');
  console.log('Input:', { projectId, field, value });
  
  try {
    // Method 1: Try getUser()
    const getUserResult = await supabase.auth.getUser();
    console.log('getUser result:', getUserResult);
    
    // Method 2: Try getSession()
    const getSessionResult = await supabase.auth.getSession();
    console.log('getSession result:', getSessionResult);
    
    // Extract email from whichever method works
    let userEmail = null;
    
    if (getUserResult.data?.user?.email) {
      userEmail = getUserResult.data.user.email;
      console.log('Got email from getUser:', userEmail);
    } else if (getSessionResult.data?.session?.user?.email) {
      userEmail = getSessionResult.data.session.user.email;
      console.log('Got email from getSession:', userEmail);
    } else {
      console.error('Could not get user email from any method');
    }
    
    // Build the update
    const updateData = {
      [field]: value,
      last_modified_by_email: userEmail,
      last_modified_at: new Date().toISOString()
    };
    
    console.log('Sending update:', updateData);
    
    // Perform the update
    const { data, error } = await supabase
      .from('projects')
      .update(updateData)
      .eq('id', projectId)
      .select('id, name, last_modified_by_email, last_modified_at')
      .single();
    
    if (error) {
      console.error('Update error:', error);
      return { success: false, error };
    }
    
    console.log('Update successful:', data);
    return { success: true, data };
    
  } catch (err) {
    console.error('Unexpected error:', err);
    return { success: false, error: err };
  }
};

// Make it available in console
if (typeof window !== 'undefined') {
  window.updateProjectWithEmailTracking = updateProjectWithEmailTracking;
  console.log('Alternative update function available: window.updateProjectWithEmailTracking(projectId, field, value)');
}